import { defineComponent } from 'vue'

import { Container, ContainerStatus } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { QueryInput } from '@skinsoft/search/src/query-input'
import { LocalizedString } from '@skinsoft/ui'
import { ContainerFeaturedCard } from '../container-featured-card'
import { ContainerSublistStatus } from './container-sublist-status'

require('./container-featured-list.scss')
export const ContainerFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLocalizedString: LocalizedString,
        sContainerFeaturedCard: ContainerFeaturedCard,
        sContainerSublistStatus: ContainerSublistStatus,
        sQueryInput: QueryInput
    },
    props: ['targetRouteName'],
    template: require('./container-featured-list.html'),
    data() {
        return {
            openContainersStatusList: [ContainerStatus.OPEN, ContainerStatus.NOT_DEFINED],
            closedContainersStatusList: [ContainerStatus.CLOSED],
            query: '',
        }
    },
    methods: {
        goToContainer(container: Container) {
            this.$router.push({ name: this.targetRouteName, params: { id: container.id }} as any)
        },
    },
})
